// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__39HBS","choiceBoxes":"toolbarselects_choiceBoxes__1j7Jm","simpleField":"toolbarselects_simpleField__RSWue"};